/* eslint-disable max-len */
import { api } from '../services/api';
import {
  DELETE_USUARIO_PATH,
  FETCH_USUARIO_PATH,
  SET_USER_HEADER_PATH,
  UPDATE_USUARIO_PATH,
} from '../services/path';
import { showErrorMessage, showSuccessMessage } from '../utils/utils';
import {
  FETCH_USER,
  UPDATE_USER,
  DELETE_USER,
  SET_USER,
  SET_USER_HEADER,
  FETCH_USUARIO_BY_ID
} from './types';

export const fetchUser = (perPage, offSet) => (dispatch) => dispatch({
  type: FETCH_USER,
  promise: api.get(`${FETCH_USUARIO_PATH}?perPage=${perPage}&offSet=${offSet}`),
});

export const fetchUsuarioById = (id) => (dispatch) => dispatch({
  type: FETCH_USUARIO_BY_ID,
  promise: api.get(`${FETCH_USUARIO_PATH}/${id}`)
});

export const editUser = (email, nombre, password, celular, estado, puesto, telegram, rol, callback) => (dispatch) => dispatch({
  type: UPDATE_USER,
  promise: api.put(UPDATE_USUARIO_PATH, {
    email,
    nombre,
    password,
    celular,
    estado,
    puesto,
    telegram,
    rol,
  }),
  meta: {
    onSuccess: () => {
      dispatch(fetchUser());
      callback();
      showSuccessMessage(
        'Succesfully! Your profile was updated correctly',
        dispatch
      );
    },
    onFailure: (res) => {
      showErrorMessage(res.message, dispatch);
    },
  },
});

export const deleteUser = () => (dispatch) => dispatch({
  type: DELETE_USER,
  promise: api.delete(DELETE_USUARIO_PATH),
});

export const setUser = (user) => (dispatch) => dispatch({
  type: SET_USER,
  user,
});
export const setUserHeader = () => (dispatch) => dispatch({
  type: SET_USER_HEADER,
  promise: api.get(SET_USER_HEADER_PATH),
});
